import React from 'react';

import { useTranslation } from 'react-i18next';
import EnglishResourceBundle from './locale/loading.en.json'
import FrenchResourceBundle from './locale/loading.fr.json'

export const Loading = () => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'loading', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'loading', FrenchResourceBundle);

    return (
        <p>{t("loading:text")}</p>
    );
}